// "Последнее действие" widget on the dashboard. Shows the most recent
// assistant summary as a dark strip (matches LastActionStrip in
// designproject/files/screens-feed.jsx HomeC), followed by a compact list of
// older entries from FEED.

import type { JSX } from 'preact';
import { T, Avatar } from '../../tokens';
import type { LastActivityEntry } from './types';

interface LastActivityProps {
  readonly entries: readonly LastActivityEntry[];
  readonly onOpenHistory: () => void;
}

export function LastActivity({
  entries,
  onOpenHistory,
}: LastActivityProps): JSX.Element | null {
  if (entries.length === 0) return null;
  // aidepo-14: чёрная плашка «последняя операция» убрана — она показывала
  // любое последнее сообщение агента (включая приветствие «Записал: Привет…»)
  // и сбивала с толку. Осталась лента последней активности.
  return <Trail entries={entries} onOpenHistory={onOpenHistory} />;
}

interface TrailProps {
  readonly entries: readonly LastActivityEntry[];
  readonly onOpenHistory: () => void;
}

function Trail({ entries, onOpenHistory }: TrailProps): JSX.Element {
  return (
    <div
      style={{
        background: T.surface,
        border: `1px solid ${T.border}`,
        borderRadius: 14,
        overflow: 'hidden',
      }}
    >
      {entries.map((entry, idx) => (
        <div
          key={entry.id}
          style={{
            display: 'flex',
            gap: 10,
            alignItems: 'flex-start',
            padding: '10px 12px',
            borderTop:
              idx === 0 ? 'none' : `1px solid ${T.divider}`,
          }}
        >
          <Avatar
            kind={entry.kind === 'user' ? 'you' : 'ai'}
            icon={entry.kind === 'user' ? 'user' : 'spark'}
            size={24}
          />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div
              style={{
                fontSize: 13,
                color: T.ink,
                fontWeight: 500,
                lineHeight: 1.35,
              }}
            >
              {entry.text}
            </div>
            <div
              style={{
                fontSize: 11,
                color: T.ink3,
                marginTop: 2,
                fontWeight: 500,
              }}
            >
              {entry.time}
            </div>
          </div>
        </div>
      ))}
      <button
        type="button"
        onClick={onOpenHistory}
        style={{
          width: '100%',
          background: T.surfaceAlt,
          border: 'none',
          borderTop: `1px solid ${T.divider}`,
          padding: '10px 12px',
          fontFamily: T.font,
          fontSize: 12.5,
          fontWeight: 600,
          color: T.ink2,
          textAlign: 'center',
          cursor: 'pointer',
        }}
      >
        Открыть историю
      </button>
    </div>
  );
}

// summarizeActions удалён вместе с HeadStrip (aidepo-14).
